import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Button, Card } from 'reactstrap';

import styles from './styles.module.scss';

export function Compliance() {
  const navigate = useNavigate();

  if (sessionStorage.getItem('vapp-terms') === 'accepted') {
    return <Navigate to="/request" />;
  }

  return (
    <main id="main">
      <Card className={`${styles.cardBackground} shadow-sm p-3`}>
        <h1>Precertification Portal</h1>
        <br />
        <h2>System Access</h2>
        <p>
          This U.S government system is intended to be used by authorized users
          for viewing and retrieving information only, except as otherwise
          explicitly authorized. VA information resides on and transmits through
          computer systems and networks funded by VA. All use is considered to
          be with an understanding and acceptance that there is no reasonable
          expectation of privacy for any data or transmissions on Government
          Intranet or Extranet (non-public) networks or systems. All
          transactions that occur on this system and all data transmitted
          through this system are subject to review and action including (but
          not limited to) monitoring, recording, retrieving, copying, auditing,
          inspecting, investigating. restricting access, blocking, tracking,
          disclosing to authorized personnel, or any other authorized actions by
          all authorized VA and law enforcement personnel. All use of this
          system constitutes understanding and unconditional acceptance of these
          terms.
          <br />
          <br />
          Unauthorized attempts or acts to either (1) access, upload, change, or
          delete information on this system, (2) modify this system, (3) deny
          access to this system, or (4) accrue resources for unauthorized use on
          this system are strictly prohibited. Such attempts or acts are subject
          to action that may result in criminal, civil, or administrative
          penalties.
        </p>
        <h2>CPT® Data Files License End User Agreement</h2>
        <p>
          (a) Licensed Content is copyrighted by the American Medical
          Association and CPT is a registered trademark of the AMA.
          <br />
          <br />
          (b) Licensee, as a party to a license agreement with the AMA, is
          authorized to grant End User a limited, non-exclusive,
          non-transferable, non-sublicensable license for End User to use
          Licensed Content in Licensee’s Licensed Product(s), for the sole
          purpose of internal use by End User within the Territory. Upon
          termination or expiration of the Agreement between Licensee and AMA,
          Licensee shall notify End User. End User shall continue to have the
          right to use Licensed Content in the Licensee’s Licensed Product(s)
          for the remainder of year of the then-current annual release (e.g.,
          through the end of the applicable calendar year)(“End User Tail
          Period”). End User’s continued use of the Licensed Content during the
          End User Tail Period is subject to End User’s continued compliance
          with all its obligations under these terms. Upon the expiration of the
          End User Tail Period, the sublicense granted under these terms shall
          automatically terminate.
          <br />
          <br />
          (c) The provision of updated Licensed Content in the Licensed
          Product(s) is dependent on a continuing contractual relationship
          between Licensee and the AMA.
          <br />
          <br />
          (d) End User is prohibited from making Licensed Content publicly
          available; creating derivative works (including translating) of the
          Licensed Content; and transferring, selling, leasing, licensing, or
          otherwise making available the Licensed Content, or a copy or portion
          of Licensed Content, to any unauthorized party, including a
          subsidiary, affiliate, or other legal entity, however designated, for
          any purpose whatsoever except as expressly permitted in this
          Agreement.
          <br />
          <br />
          (e) End User expressly acknowledges and agrees to the extent permitted
          by applicable law, use of the Licensed Content is at End User’s sole
          risk and the Licensed Content is provided “as is” without warranty of
          any kind. The AMA does not directly or indirectly practice medicine or
          dispense medical services. Fee schedules, relative value units,
          conversion factors and/or related components are not assigned by the
          AMA, are not part of CPT, and the AMA is not recommending their use.
          The Licensed Content does not replace the AMA’s Current Procedural
          Terminology book or other appropriate coding authority. The coding
          information contained in the Licensed Content should be used only as a
          guide.
          <br />
          <br />
          (f) End User is required to keep records and submit reports including
          information necessary for the calculation of royalties payable to the
          AMA by the Licensee, of the same type as required of Licensee under
          this Agreement. End User consents to the release of such information
          to the AMA. End User further agrees to provide, without delay,
          additional information that the AMA (as a third-party beneficiary) may
          reasonably request, to verify the information. Nothing herein shall
          require End User to submit or release information that would cause End
          User to be in violation of applicable federal or state privacy laws
          <br />
          <br />
          (g) The following U.S. Government End Users notice shall be included:
          U.S. Government End Users. CPT is commercial technical data, which was
          developed exclusively at private expense by the American Medical
          Association (AMA), 330 North Wabash Avenue, Chicago, Illinois 60611.
          This agreement does not grant the Federal Government a direct license
          to use CPT based on FAR 52.227-14 (Data Rights – General) and DFARS
          252.227-7015 (Technical Data – Commercial Items).
          <br />
          <br />
          (h) End User must ensure that anyone with authorized access to the
          Licensed Product(s) will comply with the provisions of the End User
          Agreement.
          <br />
          <br />
          (i) AMA shall be named as a third-party beneficiary of the End User
          Agreement.
          <br />
          <br />
          (j) End User expressly consents to the release of its name to the AMA.
        </p>
        <h2>Notices and Disclaimers</h2>
        <p>
          CPT copyright 2024 American Medical Association. All rights reserved.
          <br />
          <br />
          Fee schedules, relative value units, conversion factors and/or related
          components are not assigned by the AMA, are not part of CPT, and the
          AMA is not recommending their use. The AMA does not directly or
          indirectly practice medicine or dispense medical services. The AMA
          assumes no liability for data contained or not contained herein.
          <br />
          <br />
          CPT is a registered trademark of the American Medical Association.
        </p>
        <h2>U.S. Government End Users</h2>
        <p>
          CPT is commercial technical data, which was developed exclusively at
          private expense by the American Medical Association (AMA), 330 North
          Wabash Avenue, Chicago, Illinois 60611. Use of CPT in connection with
          this product shall not be construed to grant the Federal Government a
          direct license to use CPT based on FAR 52.227-14 (Data Rights –
          General) and DFARS 252.227-7015 (Technical Data – Commercial Items).
        </p>
        <div style={{ textAlign: 'center', fontWeight: 'bold' }}>
          Should the above terms and conditions be acceptable to you, please
          indicate your agreement and acceptance by clicking below on the button
          labeled "ACCEPT."
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '1.5rem',
          }}
        >
          <Button
            size="lg"
            onClick={() => {
              navigate('/request');
              sessionStorage.setItem('vapp-terms', 'accepted');
            }}
            color="success"
            aria-label="Accept"
          >
            Accept
          </Button>
        </div>
      </Card>
    </main>
  );
}
